"use client";

import { Check } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Benefits() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.15
  });
  const benefitsList = ["Certified and experienced instructors", "Flexible online and in-person classes", "Exam-focused curriculum for IELTS and TOEFL", "Supportive learning environment", "Progress tracking and student success support"];
  return <section id="benefits" ref={sectionRef} className="py-16 md:py-24 bg-background">
      <div className="container">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {}
          <div className={`space-y-6 transition-all duration-500 ease-smooth ${isVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-12"}`}>
            <h2 className="text-primary mb-8">
              Why Choose Unity Language Academy?
            </h2>
            <ul className="space-y-4">
              {benefitsList.map((benefit, i) => <li key={i} data-index={i} className={`flex items-start gap-4 transition-all duration-300 ease-smooth ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
              transitionDelay: isVisible ? `${i * 100}ms` : "0ms"
            }}>
                  <div className="flex-shrink-0 w-6 h-6 rounded-full bg-primary flex items-center justify-center mt-0.5">
                    <Check className="w-4 h-4 text-foreground-primary" />
                  </div>
                  <span className="text-foreground text-lg leading-relaxed">
                    {benefit}
                  </span>
                </li>)}
            </ul>
          </div>

          {}
          <div className={`relative transition-all duration-500 ease-smooth ${isVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-12"}`}>
            <div className="relative rounded-lg overflow-hidden shadow-strong">
              <img src="https://unitylanguageacademy.10web.cloud/wp-content/uploads/2026/02/post_student-success-stories-from-beginner-to-ielts-high-score.webp" alt="Student engaged in digital learning session" className="w-full h-auto object-cover" />
              <div className="absolute inset-0 shadow-[inset_0_0_20px_rgba(0,0,0,0.15)] pointer-events-none" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}